 
import axios from 'axios'
import dayjs from 'dayjs'
import irregularcell from './irregularcell'
import { getAttributeData, sheetExportExcel, updateEstimate } from '@/api/enterprise'
import config from '@/config'
import landA1 from './landA1.vue'
import landA2 from './landA2.vue'
import landB1 from './landB1.vue'
import landB2 from './landB2.vue'
import landC1 from './landC1.vue'
import landC2 from './landC2.vue'
import landC3 from './landC3.vue'
import landC4 from './landC4.vue'
import landD1 from './landD1.vue'
import landE1 from './landE1.vue'
import landE2 from './landE2.vue'
import landE3 from './landE3.vue'

import landF1 from './landF1.vue'
import landF2 from './landF2.vue'
import landF3 from './landF3.vue'

import landG1 from './landG1.vue'

import landH1 from './landH1.vue'



export default {
  components: {
    irregularcell,
    landA1,
    landA2,
    landB1,
    landB2,
    landC1,
    landC2,
    landC3,
    landC4,
    landD1,
    landE1,
    landE2,
    landE3,
    landF1,
    landF2,
    landF3,
    landG1,
    landH1
  },
  props: ['estimate_data', 'cesuanTitle', 'id', 'group_id'],
  data() {    
    return {
        focusVal: '',
        yilouDialogVisible: false,
        needInput: null,
        setCoordinate: {
        },
        layerLoading: false,
        en: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN', 'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX', 'AY', 'AZ', 'BA', 'BB', 'BC', 'BD', 'BE'],
        activeIndex: 0,
        dialogVisible: true,
        workbook:null,
        copyWorkbook: null,
        setTable1Data: {},
        clot: null,
        warnings: [
          'C2','C6','D6','E6','F6','G6','H6','I6','J6','K6','L6','M6','N6','O6','P6','Q6','R6', 'C7', 'D7', 'E7', 'F7', 'G7', 'H7', 'I7', 'J7', 'K7', 'L7', 'M7', 'N7', 'O7', 'P7', 'Q7', 'R7'   , 'C8', 'D8', 'E8', 'F8', 'G8', 'H8', 'I8', 'J8', 'K8', 'L8', 'M8', 'N8', 'O8', 'P8', 'Q8', 'R8'     , 'C11', 'D11', 'E11', 'F11', 'G11', 'H11', 'I11', 'J11', 'K11', 'L11', 'M11', 'N11', 'O11', 'P11', 'Q11', 'R11'  , 'C23', 'D23', 'E23', 'F23', 'G23', 'H23', 'I23', 'J23'    , 'C24', 'D24', 'E24', 'F24', 'G24', 'H24', 'I24', 'J24'   , 'H25', 'I25', 'J25'  , 'E46', 'E48', 'B50'  , 'B51', 'B52', 'B53', 'B54', 'B55', 'B56' , 'B57' , 'B58', 'B59', 'B60', 'B61', 'E46', 'E48', 'E50', 'E51', 'E53', 'E54', 'E59', 'G51', 'G52', 'G53', 'G54', 'G55', 'G56', 'G57', 'G58', 'G59', 'G60'  , 'C127', 'C129', 'C130', 'C131', 'C134', 'C135', 'C136',   'B141', 'C141', 'D141', 'F141',  'B142', 'C142', 'D142', 'F142',  'B143', 'C143', 'D143', 'F143',  'B144', 'C144', 'D144', 'F144',  'A242', 'B242', 'C242', 'D242',  'E242','F242','G242','H242','I242',  'C277','C278','C279','C280','C281','C282','C283','C284','C285','C286','C287','C288',     'C294','C295','C296','C297','C298','C299','C300','C301','C302','C303','C304','C305', 'C306', 
        ],
        projectList: [
          '项目基本情况及拆迁补偿标准',
          '项目规划指标',
          '地价测算',
          '建安成本',
          '投资计划',
          '销售去化和资金回款',
          '财务成本与税费',
          '敏感性分析',
        ],
    }
  },
  mounted() {
    this.setContentText()    
  },
  methods: {

      async saveStep() {
          this.layerLoading = true
          let form  = {
            estimate_data: this.setCoordinate,
            estimate_name: this.cesuanTitle,
            id: this.id,
            group_id: this.group_id
          }

          await updateEstimate(form)         
          this.layerLoading = false
      },

      calculateDistance(childNode, parentNode) {        
        let childRect = childNode.getBoundingClientRect();
        let parentRect = parentNode.getBoundingClientRect();

        let leftDistance = childRect.left - parentRect.left;
        let topDistance = childRect.top - parentRect.top;

        return {
          left: leftDistance,
          top: topDistance
        };

      },
      scrollToPosition(div, left, top) {
        div.scrollLeft = left;
        div.scrollTop = top;
      },
      doExport() {
        let that = this
        fetch(`${config.SSR_API_URL}/sheet/exportExcel`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({"setCoordinate": that.setCoordinate})
          }).then(response => {
            if (response.ok) {
              return response.blob();
            } else {
              throw new Error("Error: " + response.statusText);
            }
          }).then(blob => {
            var fileName =  that.cesuanTitle ? `${that.cesuanTitle}-${dayjs().format('YYYY年MM月DD日 HH时mm分ss秒')}.xlsx` : `工业上楼经济测算表-${dayjs().format('YYYY年MM月DD日 HH时mm分ss秒')}.xlsx`;
            saveAs(blob, fileName);
            that.yilouDialogVisible = false
            that.layerLoading = false
          }).catch(error => {
            that.layerLoading = false
            that.yilouDialogVisible = false
          });
      },
      doposition() {
        this.yilouDialogVisible = false
        $(this.needInput).addClass('layer-input-error')
        var idx = $(this.needInput).closest('.outer-container').index() -1
        this.activeIndex = idx
        this.$nextTick( () => {
          var parentNode = $('.outer-container:visible').get(0);                    
          var distance = this.calculateDistance(this.needInput, parentNode);
          this.scrollToPosition(parentNode, distance.left, distance.top - 50);
          this.needInput = null
        })
      },
      // 去除公式导出Excel
      exportExcel() {  
          let that = this
          // this.layerLoading = true
          $('.outer-container table td[id]').each( function () {                          
              if ($(this).hasClass('percentage')) {
                let cellReference = $(this).attr('id')                 
                that.setCoordinate[cellReference] = that.setCoordinate[cellReference]                
              }
          })
          
          $('.warning-need-insert').each( function () {
                let va = $(this).val()                
                if (va == 0 || !va) {
                  that.yilouDialogVisible = true     
                  that.needInput = this                                                                  
                  return false
                }
          })
          if (!this.yilouDialogVisible) {
              this.doExport()
          }
      },
      changeSelectionRef(eA) {        
        this.setCoordinate[$(eA.target).parent().attr('id')] = eA.value
        this.getAllValueFromExcel(true)
      },

     // TODO: 获取所有的单元格跟这个id相关的，然后写进去
     cellRefToIndex(cellRef) {
          let colLetters = cellRef.match(/[A-Z]+/g)[0]; // 提取列的字母
          let rowNumber = parseInt(cellRef.match(/\d+/g)[0]); // 提取行的数字

          let col = 0;
          for (let i = 0; i < colLetters.length; i++) {
              col *= 26;
              col += colLetters.charCodeAt(i) - 65 + 1;
          }

          return { row: rowNumber - 1, col: col - 1 };
     },

     async getAllValueFromExcel(isInput = false) {
        let params = {
            "sheet":"0 填写表",
            "setCoordinate": {
            },
            "getCoordinate": [

            ]
        }

        if (this.estimate_data && !isInput) {
          if (Object.keys(this.estimate_data).length > 0) {
            this.setCoordinate = this.estimate_data
          }          
        }

        params.setCoordinate  = this.setCoordinate
        
        $('.outer-container table td[id]').each( function () {            
            let cellReference = $(this).attr('id') 
            params.getCoordinate.push(cellReference)
        })
        const res = await getAttributeData(params)

        for (let key in res.data) {  
            let vald = res.data[key] == null ? 0: res.data[key]
            if (typeof vald == 'number' && !$(`#${key}`).hasClass('etda')) {
              if ($(`#${key}`).hasClass('percentage')) {
                vald = (Number(vald) * 100).toFixed(2)
              } else {
                vald = Number(vald).toFixed(2)
              }              
            }
                           
            if ($(`#${key}`).find('input').length == 0) { 
                if ($(`#${key}`).hasClass('etda')) {
                  $(`#${key}`).text(vald + '年')
                } else {
                  if (typeof vald == 'string' && vald.indexOf('-') > -1) {
                    $(`#${key}`).text('请检查数据结果')
                  } else {
                    $(`#${key}`).text(vald)
                  }
                  
                }                            
                
                if (vald == 'TRUE' || vald == 'true' || vald === true) {
                  $(`#${key}`).css('background-color', '#00b050')
                } else if (vald == 'FALSE' || vald == 'false' || vald === false ) {
                  $(`#${key}`).css('background-color', 'red')
                } else if (typeof vald == 'string' && vald.indexOf('-') > -1) {
                  $(`#${key}`).css('background-color', 'red')
                }
              } else { 
                if (!isInput) {
                    $(`#${key}`).find('input').val(this.convertDateFormat(vald))
                }
                              
            }
        }       
        this.layerLoading = false
     }, 

     getTwoDecimalPlaces(number) {
      if (typeof number == 'number') {
        return Math.round(number * 100) / 100;
      } else {
        return number
      }      
    },
    
    convertDateFormat(dateString) {
          const inputFormat = /^(\d{4})-(\d{2})-(\d{2})T00:00:00$/;
          const outputFormat = 'YYYY/MM/DD';

          if (inputFormat.test(dateString)) {
            const [, year, month, day] = inputFormat.exec(dateString);
            return `${year}/${month}/${day}`;
          } else {
            return dateString; // Return original string if format doesn't match
          }
     },
      isValidPercentageFormat(input) {
        // 定义匹配数字.数字%格式的正则表达式
        const percentageRegex = /^\d+(\.\d+)?%$/;

        // 使用test方法检查输入是否符合正则表达式
        return percentageRegex.test(input);
     },
     LoadSpread () {        
      // this.workbook.fromJSON(json)
      let that = this           

      this.$refs.landA1.assignColumnIds('testTablelandA1', 5)
      this.$refs.landA2.assignColumnIds('testTableLandA2', 22)
      this.$refs.landC2.assignColumnIds('testTableLandC2', 140)
      this.$refs.landD1.assignColumnIds('testTableLandD1', 224)
      this.$refs.landE2.assignColumnIds('testTableLandE2', 245)
      this.$refs.landE3.assignColumnIds('testTableLandE3', 258)
      this.$refs.landF1.assignColumnIds('testTableLandF1', 276)
      this.$refs.landF2.assignColumnIds('testTableLandF2', 292)
      this.$refs.landF2.assignColumnIds1('testTableLandF2-1', 309)
      this.$refs.landF3.assignColumnIds('testTableLandF3', 327)
      this.$refs.landG1.assignColumnIds('testTableLandG1', 363)

      $('.outer-container table td[id]').each( function () { 
        let tx = $(this).text()        
        if (that.isValidPercentageFormat(tx)) {
          $(this).addClass('percentage')
        }
      }) 

      $('.ete20').each( function () {
        // let str = $(this).text()
        if ($(this).hasClass('ete233')) {
          $(this).html(`<input class="layui-input-d"  style="height:35px;width: 100%;text-align:center" value="" />`)
        } else {
          $(this).html(`<input class="layui-input-d"  style="height:35px;width: 100%;text-align:center" value="${0}" type="number" step="0.01"/>`)
        }
        
      })
      
      $('body').off('focus.key').on('focus.key', '.layui-input-d', function (e) {
          that.focusVal = e.target.value
          $(e.target).removeClass('layer-input-error')
      })

      $('body').off('blur.key').on('blur.key', '.layui-input-d', function (e) {
          if (that.focusVal == e.target.value) {
            return false
          }          
          that.setCoordinate[$(this).parent().attr('id')] = !isNaN(Number(e.target.value)) ? Number(e.target.value):e.target.value
          if ($(this).parent().hasClass('percentage')) {
            that.setCoordinate[$(this).parent().attr('id')] = that.setCoordinate[$(this).parent().attr('id')] / 100
          }          
          that.getAllValueFromExcel(true)
          that.focusVal = ''
      })
      this.layerLoading = true
      this.getAllValueFromExcel()
      this.warnings.forEach( item => {
        $(`#${item}`).find('input').addClass('warning-need-insert')
      })
      
    },
    setContentText() {
      this.layerLoading = true
      setTimeout( () => {
        // this.iniTable()   
        this.LoadSpread()     
      }, 1000)
      
    },
    doprevStep() {
      this.activeIndex--
    },
    donextStep() {
        this.activeIndex++
    },
    nextStep(activeIndex) {      
      this.activeIndex = activeIndex      
    },
    hidePop() {
        this.dialogVisible = false
    },      
    async handleSuccess() {
        
    }
  }
}
